//@ts-check
import cleanPath from './cleanPath';
/**
 * @type {import("./types").stripDesignTrunkFromPathType}
 */

export default (function (path) {
  if (!path) return path;
  if (path === 'Design') return '';
  return cleanPath(path).replace('Design/', '');
});